import React, {useEffect, useState} from "react";
import toast from 'react-hot-toast';
import Dropdown from "./ds/Dropdown";
import File from "./ds/File";
import Icon from "./ds/Icon";
import Tag from "./ds/Tag";
// import RelatedArticle from "./RelatedArticle";
import {tagService, imageService} from "../container";
import config from "../config";
import {useGlobalState} from '../state';
import PostEditor from "./PostEditor";
import PostCharactersCounter from "./PostCharactersCounter";

export default function PostStructure({post, onChange}) {
  const {media} = useGlobalState();
  const [tagsResults, setTagsResults] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  // Toggle Focus
  useEffect(() => {
    document.querySelectorAll('#post-structure .input').forEach(el => {
      el.addEventListener('focus', () => {
        el.parentElement.classList.add('focus');
      });

      el.addEventListener('blur', () => {
        el.parentElement.classList.remove('focus');
      });
    });
  }, []);

  useEffect(() => {
    if (tagsResults.length > 0) {
      setTagsResults(tags => tags.filter(tag => !post.tags.some(t => t.id === tag.id)));
    }
  }, [post.tags]);

  useEffect(() => {
    if (post.image) {
      let url = post.image.url;

      if (!url?.startsWith('http')) {
        url = `${config.baseTempImagesUrl}/${url}`;
      }

      setImageUrl(url);
    }
  }, [post.image])

  // Tags
  function showTagsSearch(e) {
    e.stopPropagation();
    document.querySelector('.tags .ds-dropdown').style.display = 'block';
  }

  function hideTagsSearch() {
    document.querySelector('.tags .ds-dropdown').style.display = 'none';
  }

  async function searchTag(e) {
    let value = e.target.value;

    if (value.length >= 3) {
      try {
        const result = await tagService.search({
          media_id: media.id,
          state: 'approved',
          title: value,
        });

        if (result.length > 0) {
          setTagsResults(
            result.filter(tag => !post.tags.some(t => t.id === tag.id)),
          );
        } else {
          setTagsResults([{title: 'No hay tags que coincidan con tu búsqueda'}]);
        }
      } catch (err) {
        toast.error('Ocurrió un error al cargar los tags.');
        console.error(err);
      }
    } else {
      setTagsResults([]);
    }
  }

  function autocompleteTag(e) {
    if (e.key === 'Tab') {
      e.preventDefault();

      if (tagsResults.length > 0) {
        addTag(tagsResults[0]);
      }
    }
  }

  const uploadImage = async (file) => {
    if (uploading) {
      return;
    }

    setUploading(true);

    try {
      const res = await imageService.upload(file);
      onChange({
        image: {
          url: res.path,
          description: post.image?.description,
          temporal_key: res.path
        },
      });
    } catch (err) {
      toast.error('La imagen no cumple con los requisitos.');
      console.error(err);
    }

    setUploading(false);
  };

  const addTag = (tag) => {
    if (!tag.id) {
      return;
    }

    onChange({
      tags: [...post.tags, {
        id: tag.id,
        title: tag.title,
        slug: tag.slug,
      }],
    });

    hideTagsSearch();
  };

  return (
    <div id="post-structure">
      <div className={`title ${post.title.length < config.title.minLength ? 'error' : ''}`}>
        <input
          className="input t-heading-l"
          type="text"
          placeholder="Título..."
          maxLength={config.title.maxLength}
          value={post.title}
          onChange={(e) => onChange({title: e.target.value})}
        />
        <p className={`t-body-s ${post.title.length < config.title.minLength ? 'error' : ''}`}>
          <span>{post.title.length}</span> / {config.title.maxLength}
        </p>
      </div>

      <div
        className={`subtitle ${post.seo_title.length < config.seoTitle.minLength && post.seo_title.length > 0 ? 'error' : ''}`}>
        <input
          className="input t-heading-s"
          type="text"
          style={{
            height: '40px',
          }}
          placeholder="Título SEO (opcional)"
          maxLength={config.seoTitle.maxLength}
          value={post.seo_title}
          onChange={(e) => onChange({seo_title: e.target.value})}
        />
        <p
          className={`t-body-s ${post.seo_title.length < config.seoTitle.minLength ? 'error' : ''}`}>
          <span>{post.seo_title.length}</span> / {config.seoTitle.maxLength}
        </p>
      </div>


      <div
        className={`subtitle ${post.redirect_title.length < config.redirectTitle.minLength && post.redirect_title.length > 0 ? 'error' : ''}`}>
        <input
          className="input t-heading-s"
          type="text"
          style={{
            height: '40px',
          }}
          placeholder="Título Redirect (opcional)"
          maxLength={config.redirectTitle.maxLength}
          value={post.redirect_title}
          onChange={(e) => onChange({redirect_title: e.target.value})}
        />
        <p
          className={`t-body-s ${post.redirect_title.length < config.redirectTitle.minLength ? 'error' : ''}`}>
          <span>{post.redirect_title.length}</span> / {config.redirectTitle.maxLength}
        </p>
      </div>

      <div className={`subtitle ${post.subtitle.length < config.subtitle.minLength ? 'error' : ''}`}>
        <input
          className="input t-subheading"
          type="text"
          placeholder="Subtítulo..."
          maxLength={config.subtitle.maxLength}
          value={post.subtitle}
          onChange={(e) => onChange({subtitle: e.target.value})}
        />
        <p className={`t-body-s ${post.subtitle.length < config.subtitle.minLength ? 'error' : ''}`}>
          <span>{post.subtitle.length}</span> / {config.subtitle.maxLength}
        </p>
      </div>
      <PostEditor
        mediaHost={media.base_path}
        mediaId={media.id}
        post={post}
        onChange={(body) => {
          onChange({body: JSON.stringify(body)});
        }}
      >
        <PostCharactersCounter post={post}/>
      </PostEditor>

      {/*
      <div className="video">
        <Icon icon="video" />

        <input
          className="input t-body-m"
          type="text"
          placeholder="https://www.youtube.com/..."
          value={post.video}
          onChange={(e) => onChange({ video: e.target.value })}
        />
      </div>
      */}

      <div className="cover">
        <File
          label="Selecciona o arrastra aquí una imagen de portada"
          hint="Dimensiones recomendadas: 1920 x 1080"
          accept="image/*"
          onChange={(e) => {
            uploadImage(e.target.files[0])
          }
          }
        />
        {uploading && (
          <div style={{
            margin: '12px 12px 0 12px',
            borderRadius: '8px',
          }}>
            Cargando...
          </div>
        )}

        {post.image?.url && (
          <div style={{
            margin: '12px 12px 0 12px',
            borderRadius: '8px',
          }}>
            <img
              style={{
                width: '100%',
                borderRadius: '8px',
              }}
              src={imageUrl}
              alt="Portada"
            />
          </div>
        )}

        <input
          className="input t-body-m"
          type="text"
          placeholder="Agregar descripción..."
          value={post.image?.description}
          onChange={(e) => {
            onChange({
              image: {
                url: post.image?.url,
                description: e.target.value,
                final_path: post.image.final_path,
                slug: post.image.slug,
                temporal_key: post.image.temporal_key || post.image.url,
                image_format: post.image.image_format,
                low_quality_path: post.image.low_quality_path,
                mid_quality_path: post.image.mid_quality_path,
                high_quality_path: post.image.high_quality_path
              },
            })
          }}
        />
        <p className="t-body-s"><span>{post.image?.description?.length || 0}</span> / 100</p>
      </div>

      <div className="tags">
        <Icon icon="tag"/>

        <div className="current">
          {post.tags.map((tag) => (
            <Tag
              key={tag.id}
              type="secondary"
              label={tag.title || tag.name}
              removable
              onRemove={() => onChange({tags: post.tags.filter((t) => t.id !== tag.id)})}
            />
          ))}
        </div>

        <input
          className="input t-body-m"
          type="text"
          placeholder="Agregar tag..."
          onChange={e => searchTag(e)}
          onFocus={showTagsSearch}
          onBlur={hideTagsSearch}
          onKeyDown={e => autocompleteTag(e)}
        />

        <Dropdown>
          {tagsResults.length > 0 ? tagsResults.map((tag, index) => (
            <li key={index} onMouseDown={() => addTag(tag)}>{tag.title}</li>
          )) : (
            <li style={{pointerEvents: 'none'}}>Ingresa al menos 3 caracteres...</li>
          )}
        </Dropdown>

        <figure className="t-body-s">
          <img src="/assets/ds/icons/enter.svg"/>
          Tab
        </figure>
      </div>

      {/*
      <div className="related">
        <input className="input t-body-m" type="text" placeholder="Artículos recomendados (Opcional)" />

        <div>
          <RelatedArticle picture="/assets/temp/post-1.jpg" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit." />
          <RelatedArticle picture="/assets/temp/post-2.jpg" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit." />
        </div>
      </div>
      */}
    </div>
  )
}
